/**
 * SEO Constants
 * Centralized configuration for SEO-related values
 */

export const SEO_CONFIG = {
  SITE_NAME: "Brandly",
  SITE_URL: "https://brandly.my",
  DEFAULT_OG_IMAGE: "/og-image.png", // 1200x630 optimized for social sharing
  DEFAULT_LOCALE: "uk_UA",
  TWITTER_HANDLE: "@brandly", // Update if you have a Twitter account
} as const;
